import React from 'react';
import styled from 'styled-components';

const BrandFooterWrapper = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0px;
  z-index: 50;
  opacity: 0.9;
  width: 100%;

  & > svg {
    width: 100%;
    height: auto;
    display: block;
  }
`;

interface BrandFooterProps {
  children: React.ReactNode;
}

const BrandFooter = ({ children }: BrandFooterProps) => {
  return <BrandFooterWrapper>{children}</BrandFooterWrapper>;
};
export default BrandFooter;
